import { IdentityDto } from './../shared/identity.dto';
import { VersionDto } from './../shared/version.dto';
import { PartyDto } from './../shared/party.dto';
import { EntityDto } from './../entity/entity.dto';

export class ContractDto {
  businessUnit: string; // enum from api
  entity = new EntityDto();
  identity = new IdentityDto();
  parties: PartyDto[] = [];
  rank: number;
  startDateTime: string;
  endDateTime: string;
  type: string; // enum from api
  version: VersionDto;

  constructor(d?: ContractDto) {
    if (!d) {
      return;
    }
    this.identity = new IdentityDto(d.identity);
    this.version = new VersionDto(d.version);
    this.entity = new EntityDto(d.entity);
    this.parties = d.parties.map(p => new PartyDto(p));
    this.businessUnit = d.businessUnit;
    if (d.startDateTime) {
      this.startDateTime = d.startDateTime;
    }
    if (d.endDateTime) {
      this.endDateTime = d.endDateTime;
    }
    this.type = d.type;
    this.rank = d.rank;
  }
}
